import {
  Component,
  ViewEncapsulation,
  input,
  output,
} from '@angular/core';

/**
 * Bulk-curation header/footer nav, rendered in both the #curation panel header and the
 * chrome footer. The "N more" link is disabled until the current guest is curated
 * (isDone) and only renders when total > 0.
 */
@Component({
    selector: 'ft-bulk-curation-nav-ng',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./ft-bulk-curation-nav.component.scss'],
    templateUrl: './ft-bulk-curation-nav.component.html'
})
export class FtBulkCurationNavComponent {
    readonly hasPhoto = input(false);
    readonly isDone = input(false);
    readonly total = input(0);

    /** v1 `next()` → curationModal.moveNext() + scrollIntoView (host owns the work). */
    readonly next = output<void>();

    protected onNext(): void {
        if (!this.isDone()) return; // ft-disabled guard (pointer-events:none also blocks it)
        this.next.emit();
    }
}
